import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const Warning: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M3.725 17.5H16.275C17.5583 17.5 18.3583 16.1083 17.7167 15L11.4417 4.15834C10.8 3.05 9.2 3.05 8.55833 4.15834L2.28333 15C1.64167 16.1083 2.44167 17.5 3.725 17.5ZM10 11.6667C9.54167 11.6667 9.16667 11.2917 9.16667 10.8334V9.16669C9.16667 8.70836 9.54167 8.33336 10 8.33336C10.4583 8.33336 10.8333 8.70836 10.8333 9.16669V10.8334C10.8333 11.2917 10.4583 11.6667 10 11.6667ZM9.16667 15H10.8333V13.3334H9.16667V15Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default Warning;
